<template lang="pug">
  div(class="block-documents-status-and-send-date")
    e-documents-status(:value="value")
    block-document-send-date(
      v-if="item.scheduledAt"
      :scheduled-date="item.scheduledAt"
    )
</template>

<script>
import EDocumentsStatus from '~/modules/documents/components/elements/e-documents-status'
import BlockDocumentSendDate from '~/modules/documents/components/blocks/pro-version/block-document-send-date'

export default {
  name: 'BlockDocumentsStatusAndSendDate',
  components: {
    BlockDocumentSendDate,
    EDocumentsStatus
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped lang="scss">
.block-documents-status-and-send-date {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
